import styled from 'styled-components';

export const Searchbar = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  .ant-tooltip{
    z-index: 0 !important;
}
`;

export const ContributionSearchLabel = styled.label`
 line-height: 40px;
 width: 28%;
 text-align: right;
 font-family: HelveticaNeue;
  font-size: 14px;
  line-height: 1.29;
  letter-spacing: normal;
  color: #505050;
`;

export const SpaceBetween = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
`

export const ContributionSearchContainer = styled.div`
width: 279px !important;
z-index:11111 !important;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  .ant-tooltip{
    z-index: 0 !important;
}
  @media only screen and (min-width: 320px) and (max-width: 425px) {
    width:  auto !important;
  }
`;

